import ScrollClassToggler from "../behaviour/scoll-toggler";

document.addEventListener('DOMContentLoaded', () => {
    const toggler = new ScrollClassToggler(
        '.header-background',
        '.header-sticky',
        'header-scroll-status',
        {
            hysteresis: 80,
            debounceTime: 0,
            onClassAdded: (element) => {
                let logoSVG = document.querySelector('svg.auto-resize');

                if (!logoSVG) return;
                logoSVG.setAttribute("viewBox", "0 0 426.6 280");
            },
            onClassRemoved: (element) => {
                let logoSVG = document.querySelector('svg.auto-resize');

                if (!logoSVG) return;
                logoSVG.setAttribute("viewBox", "0 0 426.6 375.6");
            }
        }
    );

    const navigation = document.querySelector('.main-navigation');

    if (!navigation) {
        return;
    }

    const positionSubmenu = (submenu) => {
        submenu.style.setProperty('--submenu-offset-x', '0px');

        const navigationRect = navigation.getBoundingClientRect();
        const submenuRect = submenu.getBoundingClientRect();

        const minimumOffset = navigationRect.left - submenuRect.left;
        const maximumOffset = navigationRect.right - submenuRect.right;

        let offset;

        if (submenuRect.width > navigationRect.width) {
            // Ein zu breites Untermenü wenigstens rechts bündig ausrichten.
            offset = maximumOffset;
        } else {
            // Den Standardwert 0 zwischen linker und rechter Grenze halten.
            offset = Math.min(
                Math.max(0, minimumOffset),
                maximumOffset
            );
        }

        submenu.style.setProperty('--submenu-offset-x', `${offset}px`);
    };

    const positionItemSubmenu = (navigationItem) => {
        const submenu = navigationItem.querySelector(':scope > .submenu');

        if (!submenu) {
            return;
        }

        requestAnimationFrame(() => positionSubmenu(submenu));
    };

    navigation.querySelectorAll('.nav-item').forEach((navigationItem) => {
        navigationItem.addEventListener('mouseenter', () => {
            positionItemSubmenu(navigationItem);
        });

        navigationItem.addEventListener('focusin', () => {
            positionItemSubmenu(navigationItem);
        });
    });

    let resizeFrame;

    window.addEventListener('resize', () => {
        cancelAnimationFrame(resizeFrame);

        resizeFrame = requestAnimationFrame(() => {
            navigation.querySelectorAll('.nav-item').forEach((navigationItem) => {
                if (navigationItem.matches(':hover, :focus-within')) {
                    positionItemSubmenu(navigationItem);
                }
            });
        });
    });
});
